import classNames from "classnames"
import React from "react"

import GatsbyStoryblokImage from "./GatsbyStoryblokImage"
import PriceBadge, { PriceBadgeProps } from "./priceBadge"
import Typography from "./Typography"

import { Color } from "constants/V2/color"

type IconInfoBlockProps = {
  iconUrl?: string
  iconAlt?: string
  titleText: string
  titleSize?: "small" | "large"
  subTitleText?: string
  bodyHeader?: string
  bodyText: string
  priceBadge?: PriceBadgeProps
  size: "small" | "medium" | "large"
  textColor: Color
}

const IconInfoBlock = ({
  iconUrl,
  iconAlt,
  titleText,
  titleSize = "small",
  subTitleText,
  bodyHeader,
  bodyText,
  priceBadge,
  size,
  textColor,
}: IconInfoBlockProps) => {
  const getTitleSize = () => {
    if (titleSize === "large") return "h4"
    if (size === "small") return "body-md"
    if (size === "medium") return "lead-md"
    return "lead-sm"
  }

  return (
    <div
      className={classNames(
        "flex items-start",
        size === "small"
          ? "flex-row gap-16 md:flex-col"
          : size === "medium"
            ? "flex-row gap-16 md:flex-col lg:flex-row"
            : "flex-col gap-48 md:gap-64 lg:gap-88"
      )}
    >
      {iconUrl && (
        <GatsbyStoryblokImage
          image={iconUrl}
          alt={iconAlt || "Info Block Icon"}
          width={size === "small" ? 36 : size === "medium" ? 40 : 50}
        />
      )}

      <div className="flex flex-col gap-8">
        <Typography
          weight="medium"
          size={getTitleSize()}
          font="grotesk"
          color={textColor}
          text={titleText}
          leadingNone
        />

        {subTitleText && (
          <Typography
            weight="book"
            size="subscript-md"
            font="grotesk"
            color={textColor}
            text={subTitleText}
            className="pb-60"
          />
        )}

        {bodyHeader && (
          <Typography
            weight="medium"
            size="lead-sm"
            font="grotesk"
            color={textColor}
            text={bodyHeader}
            className="-mb-8"
          />
        )}
        <Typography
          weight="book"
          size={size === "small" ? "body-sm" : "body-md"}
          font="grotesk"
          color={textColor}
          text={bodyText}
        />

        {priceBadge?.text && (
          <PriceBadge
            text={priceBadge.text}
            highlight={priceBadge.highlight}
            price={priceBadge.price}
            backgroundColor={priceBadge.backgroundColor}
          />
        )}
      </div>
    </div>
  )
}

export default IconInfoBlock
